
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/speed-dial-action",
      function () {
        return require("private-next-pages/material-ui/api/speed-dial-action.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/speed-dial-action"])
      });
    }
  